export default __webpack_public_path__ + "static/media/code_1.77127456.webp";